"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSEndScene = void 0;
const Game_1 = require("./Game");
const TSCertificate_1 = require("./TSCertificate");
const TSOptions_1 = require("./TSOptions");
class TSEndScene extends Phaser.Scene {
    constructor() {
        super("TSEndScene");
    }
    init(data) {
        var _a;
        this._anim = (_a = data.anim) !== null && _a !== void 0 ? _a : true;
    }
    create() {
        this._descriptors = [];
        this._totalCount = TSOptions_1.global_save.level.get();
        this._wonCount = TSOptions_1.global_save.wins.get();
        this.audio_scene = Game_1.game_manager.add_or_get_audio_scene(this);
        this.game_width = Number(this.game.config.width);
        this.game_height = Number(this.game.config.height);
        this.addDescriptor("Hypotenuse");
        this.addDescriptor("Scalar");
        this.addDescriptor("Vector");
        this.addDescriptor("Angle");
        this.addDescriptor("Movement");
        this.addDescriptor("Subtraction");
        this.addDescriptor("Distraction");
        this.addDescriptor("Operand");
        this.addDescriptor("Operator");
        this.addDescriptor("Reaction");
        this.addDescriptor("Fraction");
        this.addDescriptor("Diffraction");
        this.addDescriptor("Supposition");
        this.addDescriptor("Speculation");
        this.addDescriptor("Hypothesis");
        this.addDescriptor("Belief");
        this.addDescriptor("Stray Thought");
        this.addDescriptor("Concept");
        this.addDescriptor("Detail");
        this.addDescriptor("Solution");
        this.addDescriptor("Way of Life");
        this.add.sprite(0, 0, 'table').setOrigin(0);
        const certificate = new TSCertificate_1.TSCertificate(this, 0, -64, `${this._wonCount}/${this._totalCount}`, this.getDescriptor(this._wonCount));
        this.add.existing(certificate);
        if (this._anim) {
            this.tweens.add({
                targets: certificate,
                delay: 1000,
                onStart: () => {
                    this.sound.add('paper_slide').play();
                },
                y: 0,
                ease: Phaser.Math.Easing.Sine.Out,
                duration: 600
            });
        }
        else {
            certificate.y = 0;
        }
        // this.add.sprite(0, 0, 'certificate').setOrigin(0)
        // this.add.bitmapText(32, 21, 'font', `${this._wonCount}/${this._totalCount}`, 6).setOrigin(0.5).setTint(0x0);
        // // this.add.bitmapText(32, 32, 'font', "YOU ARE A", 6).setOrigin(0.5).setTint(0xFFFFFF);
        // const info = this.getDescriptor(this._wonCount);
        // this.add.bitmapText(32, 43, 'font', info[0].toUpperCase(), 6).setOrigin(0.5).setTint(info[1]);
    }
    addDescriptor(title, color = 0x0) {
        if (!color) {
            const idx = this._descriptors.length;
            const hsvColor = Phaser.Display.Color.HSVToRGB(idx / (this._totalCount + 1), 1, 0.9);
            color = hsvColor.color;
        }
        this._descriptors.push([title, color]);
    }
    getDescriptor(count) {
        if (count < 0)
            return this._descriptors[0];
        if (count >= this._descriptors.length)
            return this._descriptors[this._descriptors.length - 1];
        return this._descriptors[count];
    }
}
exports.TSEndScene = TSEndScene;
